<template>
  <div class="DayOfWeekPicker">
    <date-picker :shortcuts="shortcuts" v-model="model">
      <template #input="{ props, events }">
        <v-text-field
          :label="label"
          outlined
          dense
          :hide-details="true"
          v-bind="props"
          v-on="events"
          :value="model ? daysOfWeek[model.getDay()] : ''"
        ></v-text-field>
      </template>
    </date-picker>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import '@/sass/datepicker.scss';
import moment from 'moment';

export default {
  name: 'DayOfWeekPicker',
  data() {
    return {
      daysOfWeek: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
    };
  },
  components: {
    DatePicker,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    value: {
      type: [Date, null],
      validator: (value) => {
        if (value === null) {
          return true;
        }

        return value instanceof Date && !isNaN(value.valueOf());
      },
    },
  },
  computed: {
    shortcuts() {
      return this.daysOfWeek.map((day, index) => ({
        text: day,
        onClick: () => {
          return moment().day(index).toDate();
        },
      }));
    },
    model: {
      get() {
        if (this.value === null) {
          return null;
        }

        return new Date(this.value);
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.DayOfWeekPicker {
  ::v-deep .mx-input {
    height: unset;
    border: 0;
  }

  ::v-deep .mx-datepicker-range {
    width: 100%;
  }
}
</style>
